import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";
import BrandPage from "@/pages/BrandPage";
import BrandsIndexPage from "@/pages/BrandsIndexPage";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/brands/:brandSlug" element={<BrandPage />} />
        <Route path="/brands" element={<BrandsIndexPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
